import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import OtherStatus from './ProcedureOtherStatus';
import ProcedureScheduledOrIngested from './ProcedureScheduled';


const CurrentProcedureMain = ({curProcedure}) => {

	if (!curProcedure?.status) {
		return (
			<Box component="main" maxWidth="md">
				<Typography variant="subtitle1" gutterBottom component="div" align="center">
					You do not have any scheduled appointments.
				</Typography>
			</Box>
		)
	} else {
		const curStatus = curProcedure.status;

		if (curStatus === 'scheduled' || curStatus === 'ingested') {
			return (
				<ProcedureScheduledOrIngested curProcedure={curProcedure} />
			)
		} else {
			return (
				<OtherStatus curProcedure={curProcedure} />
			)
		}
	}
}

export default CurrentProcedureMain;